import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'
import { connect } from 'react-redux'
import CircleSpinner from '../Widgets/CircleSpinner'
import {searchQueryChanged} from '../../actions'
import {
    getSearchLoading,
    getSearchQuery,
} from "../../selectors"
import {getGlobalContent} from "../../selectors/content";
import SVGSymbol from "../SVGSymbol"
import searchImage from '../../img/icons/search.svg'

class SearchInput extends PureComponent {

    componentDidMount(){
        this._input.focus();
    }

    _onQueryInputChanged = (e) => {
        const {query, handleSearch} = this.props;
        handleSearch( {
            ...query,
            query: e.target.value
        })
    }

    _setInputRef = (ref) => this._input = ref;

    render() {

        const {classes, global, className, query, loading} = this.props;

        return <div className={cn(classes.searchInputContainer, 'normalVerticalFlow', className)}>
                    <SVGSymbol icon={searchImage} className={classes.searchIcon}></SVGSymbol>
                    <input type="text" onChange={this._onQueryInputChanged} value={query.query} className={cn( classes.searchInputFont, classes.searchInput)}
                           placeholder={global.search.search_input_placeholder} ref={this._setInputRef}/>
                    <span className={cn(classes.searchInputFont, classes.searchInputShadow)}>{query.query}</span>
                    <CircleSpinner show={loading} className={classes.spinner} />
                </div>
    }
}

const mapStateToProps = (state) => {
    return {
        global: getGlobalContent(state),
        loading: getSearchLoading(state),
        query: getSearchQuery(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleSearch: ( query ) => {
            dispatch(searchQueryChanged(query))
        },
    }
}

export default injectSheet((theme) => ({
    searchInputContainer: {
        position: 'relative'
    },
    searchInputFont: {
        ...theme.font.title.h3,
        fontStyle: 'normal',
        textTransform: "none",
    },
    searchInput: {
        outline: 'none',
        '-webkit-appearance': 'none',
        backgroundImage: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        width: '100%',
        minHeight: 38,
        borderWidth: '0 0 1px 0',
        borderStyle: 'solid',
        borderColor: theme.colors.divider,
        paddingLeft: 25,
        lineHeight: 1.8,
        '&::-ms-clear': {display: 'none', lineHeight: 0},
        [theme.breakpoint('tablet')]: {
            paddingLeft: 35,
        },
        '&::-webkit-input-placeholder, &:-ms-input-placeholder, &::-moz-placeholder ': { /* Chrome */
            color: theme.colors.assent,
            opacity: 1
        },
    },
    searchInputShadow: {
        height: 1,
        backgroundColor: theme.colors.primary,
        position: 'absolute',
        bottom: 0,
        left: 0,
        overflow: 'hidden',
        minWidth: 4,
        paddingLeft: 25,
        [theme.breakpoint('tablet')]: {
            paddingLeft: 35,
        },
    },
    searchIcon: {
        position: 'absolute',
        top: 10,
        [theme.breakpoint('tablet')]: {
            top: 13,
        },
        color: theme.colors.assent
    },
    spinner: {
        position: 'absolute',
        marginTop: '-35px',
        right: 0,
    },
}))( connect(mapStateToProps, mapDispatchToProps)(SearchInput) );



// WEBPACK FOOTER //
// ./src/components/Search/SearchInput.js